module.exports = __webpack_public_path__ + "img/item1.b99f6b55.png";